// Campos de fidelización de una línea del carrito para cualquier envío al
// API (comandar `pedidos/add/accept/payment` o cobro rápido
// `pedidos/SendPaymentAndPayFast`).
//
// Una unidad canjeada con una recompensa va en el carrito a su precio de
// recompensa (p. ej. 0 €) con `loyaltyProgramId` y `loyaltyOriginalPrice`.
// El backend SOLO registra el canje (y descuenta los sellos/puntos) si la
// línea llega con `loyaltyProgramId`; sin él la trata como una línea normal
// a 0 € y la recompensa sigue disponible. Por eso todos los envíos deben
// usar este helper y no copiar los campos a mano.
export function loyaltyLineFields(line) {
  if (!line?.loyaltyProgramId) return { loyaltyProgramId: null, precioOriginal: null };
  return {
    loyaltyProgramId: line.loyaltyProgramId,
    precioOriginal: line.loyaltyOriginalPrice ?? null,
  };
}

export default loyaltyLineFields;
